import * as React from 'react';

import {RelativeTimestamp} from '../timestamp/relative-timestamp';

type Props = {
    datetime: number | null | undefined;
};

export function SendTimeCell(props: Props) {
    return <RelativeTimestamp datetime={props.datetime} format='hourHybrid' />;
}
